export enum EModalsNames {
  CustomizeDisplayTable = 'CustomizeDisplayTable',
  ProductsEditCategories = 'ProductsEditCategories',
  ProductsEditTags = 'ProductsEditTags',
  ProductCondition = 'ProductCondition',
  ProductsEditMap = 'ProductsEditMap',
  ShowAsUser = 'ShowAsUser',
  SaveFilters = 'SaveFilters',
  AddImage = 'AddImage',
  TellUs = 'TellUs',
  ImportCsv = 'ImportCsv',
  ChangePassword = 'ChangePassword',
  DeleteAccount = 'DeleteAccount'
}
